import CtaTable from './CtaTable';

export default CtaTable;
